import { PureComponent } from "react";

import { type UserAccountEntry } from "./UserAccountsPage";
import DataDrivenTable from "../../common/components/Table/DataDrivenTable";
import { EDIT_USER_URL } from "../../utils/constants";
import { Link } from "../../common/components/Link";
import { type WithTranslation } from "react-i18next";
import Chip from "../../common/components/Chip/Chip";
import { withTranslation as withTranslationBase } from "react-i18next";

interface UserAccountsTableProps extends WithTranslation {
  results: UserAccountEntry[];
}

class UserAccountsTable extends PureComponent<UserAccountsTableProps> {
  render() {
    return (
      <DataDrivenTable
        header={this.getTableHeader()}
        data={this.getTableData()}
        columnFlex={["2", "3", "1", "1", "1"]}
        className={"scha__user-accounts__table"}
      />
    );
  }

  getTableHeader() {
    const { t } = this.props;
    return [
      t("text.company.column.name.name"),
      t("text.company.column.user.id.name"),
      t("text.company.column.roles.name"),
      t("text.company.status.title"),
      "",
    ];
  }

  getTableData() {
    const { t, results } = this.props;
    const label = t("addon.text.company.manage.unit.user.edit");
    return results.map((entry) => [
      this.getName(entry),
      entry.uid,
      this.getRoles(entry),
      entry.status ? (
        <Chip>{t("addon.text.company.status.active.true")}</Chip>
      ) : (
        <Chip>{t("addon.text.company.status.active.false")}</Chip>
      ),
      <Link id={"manage_users_edit_user_" + entry.uid} href={`${EDIT_USER_URL}?user=${entry.uid}`}>
        {label}
      </Link>,
    ]);
  }

  getName(entry: UserAccountEntry) {
    return [entry.lastName, entry.firstName].filter((name) => !!name).join(", ");
  }

  getRoles(entry: UserAccountEntry) {
    const { t } = this.props;
    const entryRoles = entry.roles;
    return entryRoles.map((txt) => t(txt)).join(", ");
  }
}

export default withTranslationBase()(UserAccountsTable);
